module.exports = __webpack_public_path__ + "static/media/pic5.aeaab9c3.jpg";